import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloProviderHooks } from '@apollo/react-hooks';
import { initReactI18next } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import Honeybadger from '@honeybadger-io/js';
import i18n from 'i18next';
import React from 'react';
import ReactDOM from 'react-dom';
import store from 'store';

import 'normalize.css';
import App from './App';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import awsExports from './aws-exports';
import { configure, graphql, utils } from 'kb-shared';
import * as redux from './redux';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';
import './theme/typography.scss';
import './config/newrelic';
import { theme } from 'kb-shared';
import englishTranslation from './languages/en';
import reduxStore from './redux/store';

const { setClearPwLocalStorage, clearAmplifyLocalStorage } = utils;

const appLoaded = redux.patient.appLoaded;
const createClient = graphql.createClient;

// Turn on hot-reloading
// @ts-ignore
// module.hot && module.hot.accept();

// Configure kb-shared
const honeyBadgerConfig = {
  apiKey: process.env.REACT_APP_HONEYBADGER_KEY,
  environment: process.env.REACT_APP_HONEYBADGER_ENV,
  revision: process.env.REACT_APP_HONEYBADGER_REVISION
};

// Configure Honeybadger
// @ts-ignore
Honeybadger.configure(honeyBadgerConfig);

configure({
  bugTracker: Honeybadger,
  // Use sessionStorage so that the user is logged out when closing the browser window
  amplify: { ...awsExports, storage: sessionStorage }
});

// Configure ApolloClient
// @ts-ignore
const client = createClient(process.env.REACT_APP_APOLLO_URL);

// Configure Amplify
if (!awsExports) {
  // TEMP: trying to figure out what's wrong with aws credentials
  Honeybadger.notify('no awsExports in patient-portal index!');
}

// Platform specific config for web
setClearPwLocalStorage(() => store.remove('kindbody-auth-password'));
// Clear local amplify storage
clearAmplifyLocalStorage();

// Initial load of user into Redux
// @ts-ignore
reduxStore.dispatch(appLoaded());

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: englishTranslation
    }
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  }
});

ReactDOM.render(
  // @ts-ignore
  <ReduxProvider store={reduxStore}>
    <ApolloProvider client={client}>
      <ApolloProviderHooks client={client}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </ApolloProviderHooks>
    </ApolloProvider>
  </ReduxProvider>,
  document.getElementById('root')
);

// Turn off Service Worker
unregisterServiceWorker();
//registerServiceWorker();
